export default __webpack_public_path__ + "static/media/news.6853740f.jfif";